import { render } from "./MyStudies.vue?vue&type=template&id=14532500&scoped=true"
import script from "./MyStudies.vue?vue&type=script&lang=js"
export * from "./MyStudies.vue?vue&type=script&lang=js"

import "./MyStudies.vue?vue&type=style&index=0&id=14532500&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14532500"]])

export default __exports__